import { render, staticRenderFns } from "./NewspaperMenuSubbox.vue?vue&type=template&id=0362034e&scoped=true&"
import script from "./NewspaperMenuSubbox.vue?vue&type=script&lang=js&"
export * from "./NewspaperMenuSubbox.vue?vue&type=script&lang=js&"
import style0 from "./NewspaperMenuSubbox.vue?vue&type=style&index=0&id=0362034e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0362034e",
  null
  
)

export default component.exports